import React, { MouseEventHandler, useEffect, useMemo, useState } from 'react'
import { Typography } from 'src/components/common';
import './actionCard.scss';
import Skeleton from 'src/components/common/skeleton/Skeleton';

export default function TopUserProfile({ url, name, fallback, onClick }: { url: string, onClick?: MouseEventHandler<HTMLImageElement>, name: string, fallback?: string | number }) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isImageValid, setIsImageValid] = useState<boolean>(true);
  const memoizeUrl = useMemo(() => `${url}?t=${Date.now()}`, [url])
  useEffect(() => {
    if (!url) {
      setIsImageValid(false);
      setIsLoading(false);
      return;
    }

    // Prevent unnecessary reloading
    const img = new Image();
    img.src = url;

    if (img.complete) {
      setIsImageValid(true);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    img.onload = () => {
      setIsImageValid(true);
      setIsLoading(false);
    };

    img.onerror = () => {
      setIsImageValid(false);
      setIsLoading(false);
    };

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [memoizeUrl]);
  return (
    <>
      {isImageValid ? (
        <img src={memoizeUrl || ''} style={isLoading ? { display: 'none' } : { display: 'block' }} onClick={onClick} />
      ) : (
        <span className='user-top-3-fallback' onClick={onClick} role='img' style={isLoading ? { display: 'none' } : { display: 'block' }}>{fallback}</span>
      )}
      {isLoading && <Skeleton />}
    </>
  )
}
